import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import { getUserDisplayName } from "../../helper/common";
import { PageHeader } from "../design";
import styles from "./TenantGreeting.module.css";

const TenantGreeting = ({ user, isGuarantor = false }) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const name = getUserDisplayName(user, "").split(" ")[0] || user?.fname || "";

  if (isGuarantor) {
    const fullName = getUserDisplayName(user, "") || user?.fname || "";
    return (
      <PageHeader
        className={styles.wrap}
        onBack={() => navigate("/home")}
        backLabel={_t("backToMyProfile", "Back to my profile")}
        title={fullName}
        description={
          <>
            {_t("guarantor", "Guarantor")}
            <span aria-hidden="true" className={styles.dot}>
              ·
            </span>
            {_t("viewOnly", "View only")}
          </>
        }
      />
    );
  }

  return (
    <PageHeader
      className={styles.wrap}
      title={_t(
        "hiNameHeresYourSkorProfile",
        `Hi ${name}, here's your Skor profile`,
        undefined,
        { name }
      )}
    />
  );
};

export default TenantGreeting;
